if ($("footer#footer").length) {
    $("footer#footer").before($(".instagramFeed"));
    $(".instagram-widget>a").each(function () {
        $(".instagramFeed .igFeed").append('<div class="igPost"><a href="' + $(this).attr("href") + '" target="_blank" style="background-image: url(' + $(this).find("img").attr("data-src") + ')"></a></div>');
    });



    $(document).on("click", ".custom-footer > div .tls, .custom-footer > div .pageElement__heading", function () {
        const parent = $(this).closest(".custom-footer > div");
        $(".custom-footer > div").not(parent).removeClass("open");
        parent.toggleClass("open");
    });



    $("footer#footer .contacts").append(
        $("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"),
    );

    $("footer#footer .contacts").append(
        $("footer#footer .contact-box li span.mail").closest("li").clone().addClass("mail")
    );
    $("footer#footer .contacts span.mail").append(`<span class="infoFooter">${mailInfo}</span>`)
    $("footer#footer .contacts span.tel").append(`<span class="infoFooter">${telefonInfo}</span>`)




    $("footer#footer .socials").append(
        $("footer#footer .contact-box li span.facebook").closest("li"),
    ); $("footer#footer .socials").append(
        $("footer#footer .contact-box li span.youtube").closest("li"),
    );
    $("footer#footer .socials").append(
        $("footer#footer .contact-box li span.instagram").closest("li"),
    );

    const newsletterClone = $("footer#footer .custom-footer__newsletter").clone();
    newsletterClone.find(".consents").insertAfter(newsletterClone.find("fieldset"));
    $("footer#footer .newsletter").append(newsletterClone);


}




